import FullscreenEnterIcon from '@atlaskit/icon/core/fullscreen-enter';
import * as React from 'react';

export function SvgMaximize() {
  return <FullscreenEnterIcon label="" testId="ads-refreshed-icon" />;
}
